export default "__VITE_ASSET__Dht0_CMN__"